<!--
  Alert Dialog
  알림 팝업

  @since 2018-03-16
  @author kdydesign.kim
-->

<template>
  <q-dialog ref="alertDialog"
            @hide="onHide"
            @show="onShow"
            :dismiss-effect="false"
            :class="['bs', 'bs-q-dialog', 'bs-q-dialog-completion', getClass]">
    <div slot="body">
      <div class="dialog-body-group">
        <div class="contents-row">
          <p class="ico-dialog-completion"></p>
          <slot>
            <div v-if="code === 'ok'">
              <p>
                {{message}}
              </p>
            </div>

            <div v-else-if="code === 'newLine'">
              <p v-for="text in message">
                {{text}}
              </p>
            </div>

            <div v-else>
              <p>{{message}}</p>
            </div>
          </slot>
        </div>

        <div v-if="type === 'error' || btnType"
             class="contents-row">
          <div class="footer-option-group">
            <div class="row bs-q-btn-dialog-group">
              <q-btn :label="closeLabel"
                     :auth-force="true"
                     outline="outline"
                     @click="hide()"
                     class="bs bs-q-btn-sm bs-q-btn-icon bs-q-btn-popup-line"></q-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </q-dialog>
</template>

<script>
  import {i18n} from '../../plugins/i18n'

  export default {
    name: 'AlertDialog',
    props: {
      btnType: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        timer: void 0,
        code: '',
        errorType: '',
        message: '',
        type: 'success'
      }
    },
    computed: {
      getClass () {
        if (this.type === 'error') {
          return 'bs-q-dialog-error'
        }

        if (this.type === 'warning') {
          return 'bs-q-dialog-warning'
        }

        if (this.btnType) {
          return 'bs-q-dialog-btnAlert'
        }

        return void 0
      },
      closeLabel () {
        return i18n.t('cmn.close')
      }
    },
    methods: {
      initData () {
        this.code = ''
        this.errorType = ''
        this.message = ''
        this.type = 'success'
      },
      onHide () {
        clearTimeout(this.timer)
        this.timer = void 0
        this.$emit('hide')
        this.initData()
      },
      onShow () {
        this.$emit('show')
      },
      show (resData, type = 'success', noHide = false) {
        try {
          this.type = type

          if (_.isString(resData) && _.get(resData, ['length'], 0) > 0) {
            if (resData.replace(/\s/g, '') === '0') {
              resData = i18n.t('msg.notiMsgNetworkError', {msg: 'Network Error'})
            }
            if (resData.includes('<br>')) {
              this.message = resData.split('<br>')
              this.code = 'newLine'
            } else if (resData.includes('\n')) {
              this.message = resData.split('\n')
              this.code = 'newLine'
            } else {
              this.message = resData
              this.code = 'ok'
            }
          } else if (_.isPlainObject(resData) && _.get(resData, ['message', 'length'], 0) > 0) {
            this.code = resData.code
            this.message = this.$t(resData.message)
            this.errorType = resData.errorType
          }

          if (!this.message) {
            return
          }

          this.$nextTick(() => {
            this.$refs.alertDialog.show()
          })

          if (this.type !== 'error' && !this.btnType) {
            if (!noHide) {
              this.timer = setTimeout(() => {
                this.hide()
              }, 3000)
            }
          }
        } catch (e) {
          this.$log('[Alert Dialog GUI Error (show)]', e)
        }
      },
      hide () {
        if (typeof this.$refs.alertDialog !== 'undefined') {
          this.$refs.alertDialog.hide()
        }
      }
    }
  }
</script>
